import { render, staticRenderFns } from "./PortalSysbar.vue?vue&type=template&id=53fa0b8b&scoped=true&"
import script from "./PortalSysbar.vue?vue&type=script&lang=js&"
export * from "./PortalSysbar.vue?vue&type=script&lang=js&"
import style0 from "./PortalSysbar.vue?vue&type=style&index=0&id=53fa0b8b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fa0b8b",
  null
  
)

export default component.exports